var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    featuresAvailable,
    featuresSelected
  } = options;

__p+='\n\n';
 for(var i=0; i<featuresAvailable.length; i++) { 
__p+='\n  <div class="checkbox checkbox-primary">\n    <input type="checkbox"\n           id="feature-'+
((__t=( featuresAvailable[i]['value'] ))==null?'':__t)+
'"\n           name="feature-'+
((__t=( featuresAvailable[i]['value'] ))==null?'':__t)+
'"\n           value="'+
((__t=( featuresAvailable[i]['value'] ))==null?'':__t)+
'"\n           '+
((__t=( featuresSelected.indexOf(featuresAvailable[i]['value']) > -1 ? 'checked' : null ))==null?'':__t)+
'\n           />\n    <label for="feature-'+
((__t=( featuresAvailable[i]['value'] ))==null?'':__t)+
'">\n      '+
((__t=( featuresAvailable[i]['label'] ))==null?'':__t)+
'\n    </label>\n    <span class="float-right">\n      ('+
((__t=( featuresAvailable[i]['count'] ))==null?'':__t)+
')\n    </span>\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_feature_checkboxes.jst.ejs